import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/service-geek/apps/web/src/components/auth-redirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/service-geek/apps/web/src/components/providers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/service-geek/apps/web/src/components/SuspenseFallback.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/service-geek/apps/web/src/styles/tailwind.css");
;
import(/* webpackMode: "eager" */ "/var/www/service-geek/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
